import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false
  },
  mutations: {
    setList(state, list) {
      state.list = list;
    },
    setListLoading(state, loading) {
      state.listLoading = loading;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("ownerships");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("ownerships", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      dispatch("devices/loadAll", null, { root: true });
      return returnData;
    },
    async save({ commit, dispatch }, payload) {
      let returnData = {};
      await api
        .put("ownerships", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async end({ commit, dispatch }, payload) {
      let returnData = {};
      await api
        .put("ownerships/endOwnership", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      dispatch("devices/loadAll", null, { root: true });
      dispatch("organizations/loadAll", null, { root: true });
      return returnData;
    }
  },
  getters: {
    listLoading(state) {
      return state.listLoading;
    },
    list(state) {
      return state.list;
    }
  }
};
